import React from 'react';

const SettingsPersonalInfo = ({ profileData, handleInputChange, isEditing }) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="transform transition-all duration-500 ease-out hover:scale-105">
          <label className="block text-sm font-semibold text-gray-700 mb-2">First Name</label>
          <input
            type="text"
            value={profileData.personal.firstName}
            onChange={(e) => handleInputChange('personal', 'firstName', e.target.value)}
            disabled={!isEditing}
            className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>
        <div className="transform transition-all duration-500 ease-out hover:scale-105">
          <label className="block text-sm font-semibold text-gray-700 mb-2">Last Name</label>
          <input
            type="text"
            value={profileData.personal.lastName}
            onChange={(e) => handleInputChange('personal', 'lastName', e.target.value)}
            disabled={!isEditing}
            className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>
      </div>

      <div className="transform transition-all duration-500 ease-out hover:scale-105">
        <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
        <input
          type="email"
          value={profileData.personal.email}
          onChange={(e) => handleInputChange('personal', 'email', e.target.value)}
          disabled={!isEditing}
          className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>

      <div className="transform transition-all duration-500 ease-out hover:scale-105">
        <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
        <input
          type="tel"
          value={profileData.personal.phone}
          onChange={(e) => handleInputChange('personal', 'phone', e.target.value)}
          disabled={!isEditing}
          className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>

      <div className="transform transition-all duration-500 ease-out hover:scale-105">
        <label className="block text-sm font-semibold text-gray-700 mb-2">Bio</label>
        <textarea
          value={profileData.personal.bio}
          onChange={(e) => handleInputChange('personal', 'bio', e.target.value)}
          disabled={!isEditing}
          rows={4}
          className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed resize-none"
        />
      </div>
    </div>
  );
};

export default SettingsPersonalInfo;